/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_5_AInputs */

const en_mk_faq_5_a = /** @type {(inputs: Mk_Faq_5_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. KerjaBareng acts as a data processor, providing a DPA, audit log, and data export — your company stays the data controller.`)
};

const id_mk_faq_5_a = /** @type {(inputs: Mk_Faq_5_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya. KerjaBareng berperan sebagai prosesor data, menyediakan DPA, audit log, dan ekspor data — pengendali data tetap perusahaanmu.`)
};

/**
* | output |
* | --- |
* | "Yes. KerjaBareng acts as a data processor, providing a DPA, audit log, and data export — your company stays the data controller." |
*
* @param {Mk_Faq_5_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_5_a = /** @type {((inputs?: Mk_Faq_5_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_5_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_5_a(inputs)
	return en_mk_faq_5_a(inputs)
});